import {Component, EventEmitter, forwardRef, Input, NgModule, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

export class SdCheckboxChange {
  constructor(public source: SdCheckbox, public checked: boolean) {}
}

@Component({
  selector: 'sd-checkbox',
  standalone: true,
  template: `
    <label class="inline-flex cursor-pointer items-center gap-2 text-sm">
      <input
        type="checkbox"
        class="h-4 w-4 rounded border-[var(--m365-border-strong,#d8d8de)]"
        [checked]="checked"
        [disabled]="disabled"
        [indeterminate]="indeterminate"
        (change)="onNative($event)"
      />
      <span><ng-content></ng-content></span>
    </label>
  `,
  host: {
    class: 'sd-checkbox inline-flex',
    '[class.sd-checkbox-checked]': 'checked',
    '[class.sd-checkbox-indeterminate]': 'indeterminate',
  },
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SdCheckbox), multi: true}],
})
export class SdCheckbox implements ControlValueAccessor {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() indeterminate = false;
  @Input() color: string | undefined;
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Output() change = new EventEmitter<SdCheckboxChange>();
  @Output() checkedChange = new EventEmitter<boolean>();

  private onChange: (v: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(v: boolean): void {
    this.checked = !!v;
  }
  registerOnChange(fn: (v: boolean) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onNative(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.checked = checked;
    this.onChange(checked);
    this.onTouched();
    this.checkedChange.emit(checked);
    this.change.emit(new SdCheckboxChange(this, checked));
  }
}

@NgModule({
  imports: [SdCheckbox],
  exports: [SdCheckbox],
})
export class SdCheckboxModule {}
